export default function calculateIncomeAfterTax(salaryPm, age) {
  if (salaryPm <= 0) return 0.0;

  var x = salaryPm * 12;

  age = age ? age : 0;

  var rebate = x < 78150 ? 0 : age < 65 ? 14067 : age < 75 ? 21780 : 24354;

  var taxRate =
    x >= taxTable[taxTable.length - 1].lower
      ? taxTable[taxTable.length - 1]
      : taxTable.filter(t => x <= t.upper && x >= t.lower)[0];

  var tax = taxRate.standard + (x - (taxRate.lower - 1)) * taxRate.rate;

  x = x - tax + rebate;

  return parseFloat(x / 12).toFixed(2);
}

const taxTable = [
  { lower: 0, upper: 195850, rate: 0.18, standard: 0 },
  { lower: 195851, upper: 305850, rate: 0.26, standard: 35253 },
  { lower: 305851, upper: 423300, rate: 0.31, standard: 63853 },
  { lower: 423301, upper: 555600, rate: 0.36, standard: 100263 },
  { lower: 555601, upper: 708310, rate: 0.39, standard: 147891 },
  { lower: 708311, upper: 1500000, rate: 0.41, standard: 207448 },
  { lower: 1500001, rate: 0.45, standard: 532041 }
];



// WEBPACK FOOTER //
// ./src/helpers/TaxCalculator.js